import axios from "axios";
import { VENDORID } from "../constants";
import { CONFIG } from "../config";

//get setting
 export async function updateItemAmountRequest(item, amount) {
    var request = await axios.post(CONFIG.URL, {
            "serviceId": 2021,
            "token": sessionStorage.getItem('token'),
            "slipRef": parseInt(sessionStorage.getItem('slipRef')),
            "erpItemRef": item.itemRef,
            "erpItemUnitARef": item.itemUnitARef,
            "erpItemAmount": amount,
            "erpItemPrice": item.itemPrice,
            "erpDiscRate": sessionStorage.getItem('discRate') ? parseFloat(sessionStorage.getItem('discRate')) : 0,
            "campaignPrice": item.itemCampaignPrice,
            "erpLineExpl": "",
            "vendorId": VENDORID
          });
    return request.data;
  }